// Nav drawer menu id for the Home item. Kept here rather than inline so the
// drawer's menu entry and the page's "select me" dispatch can't drift apart.
export const HOME_MENU_ITEM_ID = 27;
